const sliceVulnerabilityId = (findingTittle: string): string => {
  const [vulnerabilityId] = findingTittle.split(". ");

  return vulnerabilityId;
};

export { sliceVulnerabilityId };
